import Vue from 'vue';

import { Log } from '@/services/log.service'
import { KombiRepository } from '@/repositories/KombiRepository'

import { store } from '@/store'
import { mapState } from 'vuex';
import router from '@/router'

import { gsap, TweenMax, TimelineMax, Power2, Power3, Power4 } from 'gsap';


/**
 * 	Übernimmt die Entscheidung und Steuerung von Übergängen
 * 	in der Animation von eine Komponenten (z.B. Kappe oder Flasche) 
 * 	zu einer anderen.
 * 
 */
export const Transition = new Vue({
	store,
	router,

	data: () => {
		return {
			globalDelay: 0,
			tweens: [],
			tweenType: Power2
		}
	},

	computed: {
		...mapState(['settings', 'presets']),
		...mapState('globals', ['animation']),
	},

	methods: {

		/**
		 * 	VOR dem Starten aller Tweens aufrufen, damit Maximal-Zeit
		 * 	des Übergangs berechnet werden kann.
		 * 
		 */
		init() {
			this.tweens = [];
			this.globalDelay = 0;
		},
		
		/**
		 * 	"Globale" Einstellungen für einen Tween einfügen
		 *
		 */
		getTween( opt ) {
			if (!opt.delay) opt.delay = 0;
			opt.delay += this.globalDelay;
			return opt;
		},

		/**
		 * 	NACH Starten aller Tweens verwenden!
		 *  
		 */
		onComplete( callback ) {
			var maxDur = 0;
			this.tweens.forEach((n) => {
				maxDur = Math.max( maxDur, n.vars.duration + n.vars.delay );
			});
			setTimeout( callback, maxDur * 1000 );
		},


		/**
		 * 	BEWEGEN einer Komponente.
		 * 	
		 */
		move( main_mc, fromEl, toEl, trans ) {
			var t = TweenMax.fromTo(toEl, 1.5, {x:fromEl.x, y:fromEl.y}, this.getTween({ease: this.tweenType.easeInOut, y:toEl.y, x:toEl.x}) );
			main_mc.removeChild( fromEl );
			this.tweens.push( t );
		},


		/**
		 * 	TAUSCHEN einer Komponente.
		 * 	
		 */
		swap( main_mc, fromEl, toEl, trans ) {

			var t;

			// Speziell für das AUSBLENDEN
			switch (fromEl.compData.key) {
				case 'flasche':
					t = TweenMax.to(fromEl, 0.5, this.getTween({ease: this.tweenType.easeIn, alpha: 0, y:100}));
					break;
				case 'verschluss':
					t = TweenMax.to(fromEl, 0.5, this.getTween({delay:0.2, ease: this.tweenType.easeIn, alpha: 0, y:50}));
					break;
				case 'huelse':
				case 'kappe':
					t = TweenMax.to(fromEl, 0.5, this.getTween({delay:0.2, ease: this.tweenType.easeIn, alpha: 0, y:-100}));
					break;
				default:
					t = TweenMax.to(fromEl, 0.3, this.getTween({alpha: 0}));
					break;
			}

			this.tweens.push( t );

			// Speziell für das EINBLENDEN
			switch (toEl.compData.key) {
				case 'flasche':
					t = TweenMax.fromTo(toEl, 2, {alpha:0, y:100}, this.getTween({delay:2, ease: this.tweenType.easeOut, alpha: 1, y:toEl.y}));
					break;
				case 'verschluss':
					t = TweenMax.fromTo(toEl, 1, {alpha:0, y:150}, this.getTween({delay:1.2, ease: this.tweenType.easeOut, alpha: 1, y:toEl.y}));
					break;
				case 'huelse':
				case 'kappe':
					t = TweenMax.fromTo(toEl, 1, {alpha:0, y:-100}, this.getTween({delay:1.2, ease: this.tweenType.easeOut, alpha: 1, y:toEl.y}));
					break;
				default:
					t = TweenMax.fromTo(toEl, 0.3, {alpha:0}, this.getTween({delay:0.4, alpha: 1}));
					break;	
			}

			this.tweens.push( t );
			TweenMax.to({a:0}, 4, this.getTween({a:1, onComplete:this.removeElements, onCompleteParams:[{remove:[fromEl], mc:main_mc}]}));
		},


		/**
		 * 	Erstmaliges EINBLENDEN einer Komponente
		 * 
		 */
		appear( main_mc, toEl, trans ) {

			var t;

			switch (toEl.compData.key) {
				case 'flasche':
					t = TweenMax.fromTo(toEl, 2, {alpha:0, y:100}, this.getTween({delay:0.8, ease: this.tweenType.easeOut, alpha: 1, y:toEl.y}));
					break;
				case 'verschluss':
					t = TweenMax.fromTo(toEl, 1, {alpha:0, y:100}, this.getTween({ease: this.tweenType.easeOut, alpha: 1, y:toEl.y}));
					break;
				case 'huelse':
				case 'kappe':
					t = TweenMax.fromTo(toEl, 1, {alpha:0, y:-100}, this.getTween({ease: this.tweenType.easeOut, alpha: 1, y:toEl.y}));
					break;
				default:
					t = TweenMax.fromTo(toEl, 0.5, {alpha:0}, this.getTween({ease: this.tweenType.easeIn, alpha: 1}));
					break;
			}

			this.tweens.push( t );
		},
		

		/**
		 * 	Ersatzloses AUSBLENDEN einer Komponente
		 * 
		 */
		disappear( main_mc, fromEl, trans ) {

			var t;

			switch (fromEl.compData.key) {
				case 'flasche':
					t = TweenMax.to(fromEl, 0.7, this.getTween({ease: this.tweenType.easeIn, alpha: 0, y:100}));
					break;
				case 'verschluss':
					t = TweenMax.to(fromEl, 0.7, this.getTween({delay:0.4, ease: this.tweenType.easeIn, alpha: 0, y:20}));
					break;
				case 'huelse':
				case 'kappe':
					t = TweenMax.to(fromEl, 1, this.getTween({ease: this.tweenType.easeIn, alpha: 0, y:-100}));
					break;
				default:
					t = TweenMax.to(fromEl, 0.5, this.getTween({ease: this.tweenType.easeIn, alpha: 0}));
					break;
			}

			this.tweens.push( t );
			TweenMax.to({a:0}, 4, this.getTween({a:1, onComplete:this.removeElements, onCompleteParams:[{remove:[fromEl], mc:main_mc}]}));
		},


		/**
		 * 	Entfernt Elemente aus dem Display-Container
		 * 
		 */
		removeElements( obj ) {
			obj.mc.removeChild( ...obj.remove );
		}


	}
});



// WEBPACK FOOTER //
// ./src/services/transition.service.js